let cartDrawerTimeout;

function openCartDrawer() {
  console.log('Opening cart drawer'); // Debug
  document.getElementById('cart-drawer').classList.add('active');
  document.querySelector('.cart-drawer-overlay').classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  document.getElementById('cart-drawer').classList.remove('active');
  document.querySelector('.cart-drawer-overlay').classList.remove('active');
  document.body.style.overflow = '';
}

function updateCartDrawer() {
  $.ajax({
    type: 'GET',
    url: '/cart?view=drawer',
    dataType: 'html',
    success: function(response) {
      $('#cart-drawer .cart-drawer__content').html($(response).find('.cart-drawer__content').html());
      
      // Update footer
      const $footer = $(response).find('.cart-drawer__footer');
      if ($footer.length) {
        $('#cart-drawer .cart-drawer__footer').replaceWith($footer);
      }
    }
  });
}

// Make functions globally available
window.openCartDrawer = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;
window.updateCartDrawer = updateCartDrawer;

$(document).ready(function() {
  console.log('Cart drawer script loaded'); // Debug
  
  // Add overlay div if it doesn't exist
  if (!$('.cart-drawer-overlay').length) {
    $('body').append('<div class="cart-drawer-overlay"></div>');
  }
  
  // Close drawer when clicking overlay
  $(document).on('click', '.cart-drawer-overlay', closeCartDrawer);
  
  // Close drawer when clicking close button
  $(document).on('click', '.cart-drawer__close', closeCartDrawer);
  
  // Update quantity
  $(document).on('click', '[data-qty-btn]', function() {
    const $input = $(this).siblings('[data-quantity-input]');
    const currentVal = parseInt($input.val());
    const isIncrease = $(this).data('qty-btn') === 'increase';
    
    const newVal = isIncrease ? currentVal + 1 : Math.max(1, currentVal - 1);
    $input.val(newVal).trigger('change');
  });
  
  // Handle quantity changes
  $(document).on('change', '[data-quantity-input]', function() {
    const $item = $(this).closest('[data-cart-item]');
    const line = $item.data('line');
    const qty = parseInt($(this).val());
    
    // Ensure quantity is at least 1
    if (qty < 1) {
      $(this).val(1);
      return;
    }
    
    clearTimeout(cartDrawerTimeout);
    cartDrawerTimeout = setTimeout(() => {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          line: line,
          quantity: qty
        },
        dataType: 'json',
        success: function(cart) {
          updateCartDrawer();
          // Update cart count
          $('#cart-count-num').html(cart.item_count);
        }
      });
    }, 500);
  });
  
  // Remove item
  $(document).on('click', '[data-remove-item]', function() {
    const $item = $(this).closest('[data-cart-item]');
    const line = $item.data('line');
    
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line: line,
        quantity: 0
      },
      dataType: 'json',
      success: function(cart) {
        updateCartDrawer();
        // Update cart count
        $('#cart-count-num').html(cart.item_count);
      }
    });
  });
});